// ****************************************/
// Favicon Flag
// ****************************************/

import styled from "styled-components";
import { font, media, underline } from "../Styles";

const FaviconFlagStyles = styled.canvas`
  position: fixed;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  pointer-events: none;
  visibility: hidden;
`;

export default FaviconFlagStyles;
